export interface ConfirmRowProps {
  message: string;
  pending: boolean;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Inline arm/confirm strip — no modal, signal-coloured per DESIGN.md's "signal colour for
 * destructive confirms". Originally `HostRailStatus`'s Finish/Archive confirm; shared here so the
 * WP10 admin template list/editor (draft delete, publish) render the same look. */
export function ConfirmRow({ message, pending, confirmLabel, onConfirm, onCancel }: ConfirmRowProps) {
  return (
    <div className="flex w-full flex-col gap-2 rounded-md border border-signal/60 bg-bg-elevated px-3 py-2">
      <p className="text-sm text-text">{message}</p>
      <div className="flex gap-2">
        <button
          type="button"
          disabled={pending}
          onClick={onConfirm}
          className="min-h-tap flex-1 rounded-md border border-signal bg-signal/10 px-3 text-sm font-semibold text-signal disabled:opacity-50"
        >
          {confirmLabel}
        </button>
        <button
          type="button"
          disabled={pending}
          onClick={onCancel}
          className="min-h-tap flex-1 rounded-md border border-border-strong px-3 text-sm font-semibold text-text-muted disabled:opacity-50"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
